export default "__VITE_ASSET__DpDozC_Y__"